import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class SysAccountParallelVoucherListRuleDetailAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'SysAccountParallelVoucherListRuleDetails';
  /**
   * Lấy chia tiết dữ liệu rule hạch toán đồng thời theo id
   * HTHIEP 08.07.2022
   */
  getDataById(id) {
    let request = {
      url: this.getAPIUrl() + '/by',
      data: id,
    };

    return httpClient.getAsync(request);
  }
}

export default new SysAccountParallelVoucherListRuleDetailAPI();
